import React from "react";
import { Clock, Download } from 'react-feather';

import './index.scss'

const DownloadButton = ({
  onClick,
  loading,
  title,
  loadingText
}) => {


  return (
    <>
      {
        loading ?
          <div className="download-button__download__loading"><Clock />Loading {loadingText}</div>
          :
          <div className="download-button__download" onClick={onClick}><Download />{title}</div>
      }
    </>
  )
}

export default DownloadButton
